// extracted by mini-css-extract-plugin
export default {"container":"wrapper_container__xTIHK"};